import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [files, setFiles] = useState([]);
  const [file, setFile] = useState(null);

  const isLoggedIn = !!localStorage.getItem('token');

  // Fetch courses
  useEffect(() => {
    fetch(`${API_BASE_URL}/courses`)
      .then(res => res.json())
      .then(data => setCourses(data))
      .catch(err => console.error('Error fetching courses:', err));
  }, []);

  // Fetch uploaded files
  useEffect(() => {
    fetch(`${API_BASE_URL}/files`)
      .then(res => res.json())
      .then(data => setFiles(data))
      .catch(err => console.error('Error fetching files:', err));
  }, []);

  // Handle file upload
  const handleUpload = async () => {
    if (!file) return alert('Please select a file first');

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await fetch(`${API_BASE_URL}/upload`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: formData,
      });

      const data = await res.json();
      if (res.ok) {
        alert('File uploaded successfully!');
        setFiles(prev => [...prev, data.filename]);
      } else {
        alert(data.error || 'Upload failed');
      }
    } catch (err) {
      console.error('Upload error:', err);
      alert('Something went wrong');
    }
  };

  // Handle file delete
  const handleDelete = async (filename) => {
    if (!window.confirm(`Are you sure you want to delete ${filename}?`)) return;

    try {
      const res = await fetch(`${API_BASE_URL}/files/${encodeURIComponent(filename)}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const data = await res.json();
      if (res.ok) {
        alert('File deleted successfully!');
        setFiles(prev => prev.filter(f => f !== filename));
      } else {
        alert(data.error || 'Delete failed');
      }
    } catch (err) {
      console.error('Delete error:', err);
      alert('Something went wrong');
    }
  };

  // Force download helper
  const handleDownload = async (filename) => {
    try {
      const res = await fetch(`http://localhost:5000/uploads/${encodeURIComponent(filename)}`);
      if (!res.ok) throw new Error('Download failed');

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = filename; // force download with original name
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download error:', err);
      alert('Failed to download file');
    }
  };

  return (
    <div className="courses">
      <h2>Courses We Offer</h2>
      <ul className="course-list">
        {courses.map(course => (
          <li key={course.id}>{course.title}</li>
        ))}
      </ul>

      <div className="download-section">
        <h3>Course content</h3>
        {files.length > 0 ? (
          <ul className="file-list">
            {files.map(file => (
              <li key={file}>
                <button
                  onClick={() => handleDownload(file)}
                  className="download-button"
                >
                  📥 {file}
                </button>
                {isLoggedIn && (
                  <button
                    onClick={() => handleDelete(file)}
                    className="delete-button"
                    style={{ marginLeft: '10px', color: 'red' }}
                  >
                    ❌ Delete
                  </button>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p>No files available yet.</p>
        )}
      </div>

      {isLoggedIn && (
        <div className="upload-section">
          <h3>Upload New Course Material</h3>
          <input type="file" onChange={e => setFile(e.target.files[0])} />
          <button onClick={handleUpload}>Upload</button>
        </div>
      )}
    </div>
  );
};

export default Courses;